import {Parser, Generator} from 'sparqljs';
import settings from './settings';

const parser = new Parser();
const generator = new Generator();

let default_graph = settings.catalog.graph.public;
if (window.Liferay){
    if (window.Liferay.ThemeDisplay.isSignedIn())
    default_graph =settings.catalog.graph.signed;
}

const default_catalog = settings.catalog.iri;

/** Класс описывающий запрос на получение и обновление данных  */
export class Request {
    constructor(sparql, graph = null){
        this._pattern = sparql;
        this._graph = graph;
        this._request = parser.parse(sparql);
    }

    get pattern () { return this._pattern;};
    set pattern (sparql) { this._pattern = sparql; this._request = parser.parse(sparql);};

    get graph () { return this._graph;};
    get sparql () { return generator.stringify(this._request);};

    get request () {return this._request;};
    set request (request) {this._request = request;};

    clone() {return new Request(generator.stringify(this._request), this._graph); };
    clear() {this._request = parser.parse(this._pattern);};
    cloneOriginal() {return new Request(this._pattern, this._graph); };
}

/** Получение списка всех предикат->объект  для субъекта */
class PredicatSubject extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); }
    setIRI(iri){
        this._request.where[0].triples[0]["subject"].id = iri;
        this._request.prefixes.URI = iri;
    }
};
const predicatSubject_sparql = 'PREFIX IRI: <http://hbz.ru/adms/skos> '+
' select DISTINCT ?predicat ?object '+
' where { IRI: ?predicat ?object } ';
export const PredicatSubjectRequest = new PredicatSubject(predicatSubject_sparql, default_graph);

/** Получение количество триплетов, для которых subject равен параметру */
class CountSubject extends Request{
    constructor(sparql, graph = null){ super(sparql, graph); }
    setIRI(iri){
        this._request.variables[0].expression.expression.id = iri;
        this._request.where[0].triples[0]["subject"].id = iri;
        this._request.prefixes.IRI = iri;
    }
};
const countSubject_sparql = 'PREFIX IRI: <http://www.w3.org/2004/02/skos/core#inScheme> '+
' select (COUNT( IRI: ) AS ?count) '+
' where { IRI: ?pr ?ob }';
export const CountSubjectRequest = new CountSubject(countSubject_sparql, default_graph);

/** Запросы для получения данные в Virtuoso */

/** Получение списка доступных активов */
const admsAssets_graph  = default_graph;
// const admsAssets_sparql = 'select ?IRI ?dsn ?dsv ?dcp ' +
// 'where { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> ?IRI .'+
// '    ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn .'+
// '    OPTIONAL{ ?IRI <http://www.w3.org/2002/07/owl#versionInfo> ?dsv }. '+ //}
// '    OPTIONAL{ ?IRI <http://purl.org/dc/terms/description> ?dcp FILTER ((LANG(?dcp) = "ru")) }.  }';
// //' FILTER (  (strStarts(?dsn, "S") || strStarts(?dsn, "F") || strStarts(?dsn, "R")) && contains(?dsn, "O") ) } ';
// 'ORDER BY ?dsn ?dsv ?IRI OFFSET 0 LIMIT 1000';

const admsAssets_sparql = 'SELECT ?IRI ?dsn ?dsv ?dcp '+
'WHERE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> ?IRI.'+
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_1 FILTER( (LANG(?dsn_1)) = "" )} .'+
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_2 FILTER( (LANG(?dsn_2)) = "ru" )} .'+
'  OPTIONAL { ?IRI <http://www.w3.org/2002/07/owl#versionInfo> ?dsv } .'+
'  OPTIONAL { ?IRI <http://purl.org/dc/terms/description> ?dcp FILTER((LANG(?dcp)) = "ru") } .'+
'  BIND ( IF(STRLEN(?dsn_2) > 0, ?dsn_2, ?dsn_1) as ?dsn)'+
'} order by ?dsn';
export const admsAssets = new Request(admsAssets_sparql, admsAssets_graph);

/** Получение количества доступных активов */
const admsAssetsCount_sparql = 'select (COUNT(distinct ?IRI) AS ?count) '+
'where { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> ?IRI .}' ;//+
// '  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_1 FILTER( (LANG(?dsn_1)) = "" )} .'+
// '  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_2 FILTER( (LANG(?dsn_2)) = "ru" )} .'+
// '  OPTIONAL { ?IRI <http://www.w3.org/2002/07/owl#versionInfo> ?dsv } .'+
// '  OPTIONAL { ?IRI <http://purl.org/dc/terms/description> ?dcp FILTER((LANG(?dcp)) = "ru") } .'+
// '  BIND ( IF(STRLEN(?dsn_2) > 0, ?dsn_2, ?dsn_1) as ?dsn)'+
// '} order by ?dsn';
export const AdmsAssetsCountRequst = new Request(admsAssetsCount_sparql, admsAssets_graph);


/** Получение списка классификационных схем, связанных с каталогом актива */
const admsThemeTaxonomy_sparql = 'select ?IRI '+
'where { <'+default_catalog+'> <http://www.w3.org/ns/dcat#themeTaxonomy> ?IRI}';
export const admsThemeTaxonomy = new Request(admsThemeTaxonomy_sparql, admsAssets_graph);

/** Добавление нового элемента в каталог */
class NewAssetInCatalog extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(catalog, IRI, label, lang){
        const value = '"'+label+'"'+((lang)?"@"+lang:"");
        //console.log("NewAssetInCatalog.setValues", catalog, IRI, label, lang, value);
        this._request.updates[0].insert[0].triples[0]["subject"].id = catalog;
        this._request.updates[0].insert[0].triples[0]["object"].id = IRI;
        this._request.updates[0].insert[0].triples[1]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[2]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[2]["object"].id = value;
        this._request.updates[0].insert[0].triples[3]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[4]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[5]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[6]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[7]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[8]["subject"].id = IRI;
        this._request.prefixes.IRI = IRI;
    }
};
export const admsNewAsset_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE {} '+
' INSERT { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> IRI: . '+

//' IRI: <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/ns/adms#Asset> . '+
' IRI: <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/ns/dcat#Dataset> . '+
' IRI: <http://www.w3.org/2000/01/rdf-schema#label> "Asset Name"@ru . '+
//Добавим основные классификации
' IRI: <http://www.w3.org/ns/dcat#theme> <http://hbz.ru/adms/internal> . '+
' IRI: <http://www.w3.org/ns/dcat#theme> <http://hbz.ru/skos/NotLocalized> . '+
' IRI: <http://www.w3.org/ns/dcat#theme> <http://hbz.ru/skos/SematicWeb> . '+
' IRI: <http://www.w3.org/ns/dcat#theme> <http://hbz.ru/skos/DomainModel> . '+
' IRI: <http://www.w3.org/ns/dcat#theme> <http://hbz.ru/skos/BasicModel> . '+
' IRI: <http://www.w3.org/ns/dcat#theme> <http://hbz.ru/skos/WithoutNotations> } '+

' WHERE {}'
//' IRI: <http://purl.org/dc/terms/language> <http://hbz.ru/adms/ru> . }'
export const NewAssetInCatalogRequest = new NewAssetInCatalog(admsNewAsset_sparql, admsAssets_graph);

/** Удаление элемента из каралога, с удалением всех триплетов имеющих subject iri элемента */
class DeleteAssetInCatalog extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setCatalog(catalog){
        this._request.updates[0].delete[0].triples[0]["subject"].id = catalog;
        this._request.updates[0].where[0].triples[0]["subject"].id = catalog;
    }
    setIRI(IRI){
        this._request.updates[0].delete[0].triples[0]["object"].id = IRI;
        this._request.updates[0].delete[0].triples[1]["subject"].id = IRI;
        this._request.updates[0].where[0].triples[0]["object"].id = IRI;
        this._request.updates[0].where[0].triples[1]["subject"].id = IRI;
        this._request.prefixes.DEL_IRI = IRI;
    }
};
export const admsDeleteAsset_sparql = 'PREFIX DEL_IRI: <http://purl.org/dc/terms/n3> '+
' DELETE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> DEL_IRI: . '+
' DEL_IRI: ?prop ?val } '+
' INSERT {} '+
' WHERE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> DEL_IRI: . '+
' DEL_IRI: ?prop ?val . }';
export const DeleteAssetInCatalogRequest = new DeleteAssetInCatalog(admsDeleteAsset_sparql, admsAssets_graph);

/** Исключение линка ассета в каталоге  */
class UnlinkAssetInCatalog extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setCatalog(catalog){
        this._request.updates[0].delete[0].triples[0]["subject"].id = catalog;
        this._request.updates[0].where[0].triples[0]["subject"].id = catalog;
    }
    setIRI(IRI){
        this._request.updates[0].delete[0].triples[0]["object"].id = IRI;
        this._request.updates[0].where[0].triples[0]["object"].id = IRI;
        this._request.prefixes.IRI = IRI;
    }
};
export const admsUnlinkAsset_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> IRI: } '+
' INSERT {} '+
' WHERE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> IRI: } ';
export const UnlinkAssetInCatalogRequest = new UnlinkAssetInCatalog(admsUnlinkAsset_sparql, admsAssets_graph);

/** Получение списка всех концептов из схемы */
class SkosConceptInScheme extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setConceptScheme(taxonomy){
        this._request.where[0].triples[2]["object"].id = taxonomy;
        this._request.prefixes.IRI_SCHEMA = taxonomy;
    }
};
const skosConceptInScheme_sparql= 'PREFIX IRI_SCHEMA: <http://csi.semanticpro.org/authority/language>'+
' select ?IRI ?Label'+
' where { ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/2004/02/skos/core#Concept> .'+
'    ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?Label .'+
'    ?IRI <http://www.w3.org/2004/02/skos/core#inScheme> IRI_SCHEMA: }';
export const skosConceptInScheme = new SkosConceptInScheme(skosConceptInScheme_sparql, admsAssets_graph);

/** Получение количества связанных концептов с http://hbz.ru/adms/Asset */
const skosConceptLinkCount_sparql= 'select ?theme (COUNT(distinct ?IRI) AS ?cnt) '+
'WHERE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> ?IRI. '+
'    ?IRI <http://www.w3.org/ns/dcat#theme> ?theme. '+
'    FILTER(?theme = <http://hbz.ru/skos/Dictionary>) }'+
' group by ?theme';
class SkosConceptLinkCount extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); }

    setConceptIRI(uri){
        this._request.where[1].expression.args[1].id = uri;
    }
    cloneOriginal() {return new SkosConceptLinkCount(this._pattern, this._graph); };
};

export const SkosConceptLinkCountRequest = new SkosConceptLinkCount(skosConceptLinkCount_sparql, admsAssets_graph);

/** Получение информации метке (label) по URI субъекта */
class RdfsLabel extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); }
    setURI(uri){
        this._request.where[0].triples[0]["subject"].id = uri;
        this._request.prefixes.URI_PROP = uri;
    }
};
const rdfsLabel_sparql = 'PREFIX URI_PROP: <http://www.w3.org/2004/02/skos/core#inScheme>'+
' select DISTINCT ?label '+
' where {   URI_PROP: <http://www.w3.org/2000/01/rdf-schema#label> ?label }' ;
export const RdfsLabelRequest = new RdfsLabel(rdfsLabel_sparql, admsAssets_graph);    

/** Получить информацию об описании (description) по IRI субъекта http://purl.org/dc/terms/description  */
class DCTermsDescription extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); }
    setURI(uri){
        this._request.where[0].triples[0]["subject"].id = uri;
        this._request.prefixes.URI_PROP = uri;
    }
};
const dctermsDescription_sparql = 'PREFIX URI_PROP: <http://www.w3.org/ns/adms#Asset>'+
' select DISTINCT ?description '+
' where {   URI_PROP: <http://purl.org/dc/terms/description> ?description }' ;
export const DCTermsDescriptionRequest = new DCTermsDescription(dctermsDescription_sparql, admsAssets_graph);    

/** Получение первых букв в названиях и их количествоа */
const rdfsLabelFirstCharCount_sparql='SELECT (SUBSTR(?dsn, 1, 1) as ?firstlitera) (count(?IRI) as ?cnt) '+
'WHERE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> ?IRI. '+
'  ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn } '+
// '  ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn. '+
// '  OPTIONAL { ?IRI <http://www.w3.org/2002/07/owl#versionInfo> ?dsv. } '+
// '  OPTIONAL { ?IRI <http://purl.org/dc/terms/description> ?dcp. '+
// '    FILTER((LANG(?dcp)) = "ru"^^<http://www.w3.org/2001/XMLSchema#string>) }} '+
' group by ?dsn '+
' order by ?firstlitera';
export const RdfsLabelFirstCharCountRequest = new Request(rdfsLabelFirstCharCount_sparql, admsAssets_graph);    
// /** Получение информации об элементе */
// class ValuesRequest extends Request {
//     constructor(sparql, graph = null){ super(sparql, graph); }
//     setIRI(iri){
//         this._request.where[0].triples[0]["subject"].id = iri;
//         this._request.prefixes.IRI = iri;
//     }
// };
// const values_sparql = 'PREFIX IRI: <http://hbz.ru/adms/skos> '+
// ' select DISTINCT ?property_uri ?val_uri ?val_label '+
// ' where { IRI: ?property_uri ?val_uri . '+
// '     ?val_uri <http://www.w3.org/2000/01/rdf-schema#label> ?val_label }';
// export const values = new ValuesRequest(values_sparql, admsAssets_graph);


/** Удаление элемента из Asset, с удалением всех триплетов имеющих subject iri элемента */
class DeleteElementInAsset extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setAsset(asset){
        this._request.updates[0].delete[0].triples[0]["subject"].id = asset;
        this._request.updates[0].where[0].triples[0]["subject"].id = asset;
    }
    setIRI(IRI){
        this._request.updates[0].delete[0].triples[0]["object"].id = IRI;
        this._request.updates[0].delete[0].triples[1]["subject"].id = IRI;
        this._request.updates[0].where[0].triples[0]["object"].id = IRI;
        this._request.updates[0].where[0].triples[1]["subject"].id = IRI;
        this._request.prefixes.DEL_IRI = IRI;
    }
};
export const admsDeleteWikiInAsset_sparql = 'PREFIX DEL_IRI: <http://purl.org/dc/terms/n3> '+
' DELETE { <http://hbz.ru/adms/asset> <http://hbz.ru/ontologies/emd/wiki> DEL_IRI: . '+
' DEL_IRI: ?prop ?val } '+
' INSERT {} '+
' WHERE { <http://hbz.ru/adms/asset> <http://hbz.ru/ontologies/emd/wiki> DEL_IRI: . '+
' DEL_IRI: ?prop ?val . }';
export const DeleteWikiInAssetRequest = new DeleteElementInAsset(admsDeleteWikiInAsset_sparql, admsAssets_graph);

export const admsDeleteDistributionInAsset_sparql = 'PREFIX DEL_IRI: <http://purl.org/dc/terms/n3> '+
' DELETE { <http://hbz.ru/adms/asset> <http://www.w3.org/ns/dcat#distribution> DEL_IRI: . '+
' DEL_IRI: ?prop ?val } '+
' INSERT {} '+
' WHERE { <http://hbz.ru/adms/asset> <http://www.w3.org/ns/dcat#distribution> DEL_IRI: . '+
' DEL_IRI: ?prop ?val . }';
export const DeleteDistributionInAssetRequest = new DeleteElementInAsset(admsDeleteDistributionInAsset_sparql, admsAssets_graph);


/** Добавление нового элемента в Asset */
class NewElementInAsset extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setAsset(asset){
        this._request.updates[0].insert[0].triples[0]["subject"].id = asset;
    }
    setValues(IRI, label, description, URL, lang){
        this._request.updates[0].insert[0].triples[0]["object"].id = IRI;
        this._request.updates[0].insert[0].triples[1]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[2]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[3]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[4]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[5]["subject"].id = IRI;
        this._request.prefixes.IRI = IRI;
        const value = '"'+label+'"'+((lang)?"@"+lang:"");
        this._request.updates[0].insert[0].triples[2]["object"].id = value;
        this._request.updates[0].insert[0].triples[3]["object"].id = value;
        const value2 = '"'+description+'"'+((lang)?"@"+lang:"");
        this._request.updates[0].insert[0].triples[4]["object"].id = value2;        
        this._request.updates[0].insert[0].triples[5]["object"].id = URL;        
    }
};
export const admsNewWiki_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE {} '+
' INSERT { <http://hbz.ru/adms/asset> <http://hbz.ru/ontologies/emd/wiki> IRI: . '+
' IRI: <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://hbz.ru/teamwork/wiki> . '+
' IRI: <http://www.w3.org/2000/01/rdf-schema#label> "Wiki Name"@ru . '+
' IRI: <http://purl.org/dc/terms/title> "Wiki Name"@ru . '+
' IRI: <http://purl.org/dc/terms/description> "Wiki Description"@ru . '+
' IRI: <http://hbz.ru/ontologies/emd/wiki> <http://hbz.ru/ontologies/emd/wiki> } '+
' WHERE {}'
export const NewWikiInAssetRequest = new NewElementInAsset(admsNewWiki_sparql, admsAssets_graph);

export const admsNewDistribution_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE {} '+
' INSERT { <http://hbz.ru/adms/asset> <http://www.w3.org/ns/dcat#distribution> IRI: . '+
' IRI: <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/ns/adms#AssetDistribution> . '+
' IRI: <http://www.w3.org/2000/01/rdf-schema#label> "Wiki Name"@ru . '+
' IRI: <http://purl.org/dc/terms/title> "Wiki Name"@ru . '+
' IRI: <http://purl.org/dc/terms/description> "Wiki Description"@ru . '+
' IRI: <http://www.w3.org/ns/dcat#downloadURL> "http://www.w3.org/ns/dcat#downloadURL" } '+
' WHERE {}'
export const NewDistributionInAssetRequest = new NewElementInAsset(admsNewDistribution_sparql, admsAssets_graph);

/** Запрос для получения содержимого ЕМД */
const contentEMD_sparql = 'SELECT ?s ?p ?o WHERE { ?s ?p ?o }';
class ContentEMD extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setGraph(newGraph) {this._graph = newGraph;};
};
export const ContentEMDRequest = new ContentEMD(contentEMD_sparql, default_graph);

/** Запрос для получения содержимого ЕМД */
const contentIEP_sparql = 'SELECT ?s ?p ?o WHERE { ?s ?p ?o }';
class ContentIEP extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setGraph(newGraph) {this._graph = newGraph;};
};
export const ContentIEPRequest = new ContentIEP(contentIEP_sparql, default_graph);

/** Добавление нового свойства  в Asset */
export const admsAddInAssetProperty_sparql = ' DELETE {} '+
' INSERT { <http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> "" }'+
' WHERE {}'

class AddPropertyInAsset extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(IRI, prefix, lang){
        this._request.updates[0].insert[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[0]["predicate"].id = prefix;
    }
};

export const AddPropertyInAssetRequest = new AddPropertyInAsset(admsAddInAssetProperty_sparql, admsAssets_graph);

/**
 * Удаление свойства 
 */
 const removePropertyInAsset_sparql = 'PREFIX DEL_IRI: <http://purl.org/dc/terms/n3> '+
 ' DELETE { <http://csi.semanticpro.org/temp> DEL_IRI: ?val } '+
 ' INSERT {} '+
 ' WHERE { <http://csi.semanticpro.org/temp> DEL_IRI: ?val . }';
 
class RemovePropertyInAsset extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(IRI, prefix ){
        this._request.prefixes.DEL_IRI = prefix;
        this._request.updates[0].delete[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].delete[0].triples[0]["predicate"].id = prefix;
        this._request.updates[0].where[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].where[0].triples[0]["predicate"].id = prefix;
    }
};

export const RemovePropertyInAssetRequest = new RemovePropertyInAsset(removePropertyInAsset_sparql, admsAssets_graph);

/**
 * Обновление литерального свойства
 */
 export const updateLiteralProperty_sparql = ' DELETE {<http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> ""@ru } '+
 ' INSERT { <http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> ""@ru }'+
 ' WHERE {}';

 class UpdateLiteralProperty extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(IRI, predicat, oldValue, newValue, lang ){
        this._request.updates[0].delete[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].delete[0].triples[0]["predicate"].id = predicat;
        this._request.updates[0].delete[0].triples[0]["object"].id = "\""+oldValue+"\""+"@"+lang;
        this._request.updates[0].insert[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[0]["predicate"].id = predicat;
        this._request.updates[0].insert[0].triples[0]["object"].id = "\""+newValue+"\""+"@"+lang;;
    }
};

export const UpdateLiteralPropertyRequest = new UpdateLiteralProperty(updateLiteralProperty_sparql, admsAssets_graph);


/**
 * Обновление литерального свойства
 */
 export const updateObjectProperty_sparql = ' DELETE {<http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> <http://csi.semanticpro.org/temp> } '+
 ' INSERT { <http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> <http://csi.semanticpro.org/temp> }'+
 ' WHERE {}';

 class UpdateObjectProperty extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(IRI, predicat, oldValue, newValue){
        this._request.updates[0].delete[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].delete[0].triples[0]["predicate"].id = predicat;
        this._request.updates[0].delete[0].triples[0]["object"].id = oldValue;
        this._request.updates[0].insert[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[0]["predicate"].id = predicat;
        this._request.updates[0].insert[0].triples[0]["object"].id = newValue;
    }
};

export const UpdateObjectPropertyRequest = new UpdateObjectProperty(updateObjectProperty_sparql, admsAssets_graph);

/**
 * Получение списка индивидуалов
 */
 const namedIndividuals_sparql = 'PREFIX RDF_TYPE: <http://www.w3.org/2002/07/owl#NamedIndividual> '+
 ' select DISTINCT ?subject '+
 ' where { ?subject <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> RDF_TYPE: } ';
 
class NamedIndividuals extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setType(iri){
        this._request.where[0].triples[0]["object"].id = iri;
        this._request.prefixes.RDF_TYPE = iri;
    }
};

export const NamedIndividualsRequest = new NamedIndividuals(namedIndividuals_sparql, admsAssets_graph);

/** Удаляет свойство */
const deleteLiteralValueInProperty_sparql = ' DELETE {<http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> "" } '+
' INSERT { } WHERE {}';
const deleteLinkValueInProperty_sparql = ' DELETE {<http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> <http://csi.semanticpro.org/temp> } '+
' INSERT { } WHERE {}';
class DeleteValueInProperty extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(IRI, predicat, value){
        this._request.updates[0].delete[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].delete[0].triples[0]["predicate"].id = predicat;
        if (value.startsWith("http"))
            this._request.updates[0].delete[0].triples[0]["object"].id = value;
        else
            this._request.updates[0].delete[0].triples[0]["object"].id = "\""+value+"\"";
    }
};
export const DeleteLiteralValueInPropertyRequest = new DeleteValueInProperty(deleteLiteralValueInProperty_sparql, admsAssets_graph)
export const DeleteLinkValueInPropertyRequest = new DeleteValueInProperty(deleteLinkValueInProperty_sparql, admsAssets_graph)
